module.exports = __webpack_public_path__ + "assets/2abd4b520948943207f4a4cce3f45bfd.png";